import { Injectable } from '@angular/core';

import * as FuelCardReducer from '../reducers';
import * as FuelCardActions from '../actions/fuel-card.actions';
import { ActionsSubject, Store } from '@ngrx/store';
import { ofType } from '@ngrx/effects';
import { FuelingMergeBase } from '../../../fuel-card/models/fueling-merge-base';
import { unMergeFuelingMerge } from '../actions/fuel-card.actions';
import { FuelingMerge } from '../../../fuel-card/models/fueling-merge';

@Injectable({
  providedIn: 'root'
})
export class FuelCardFacade {

  public fuelCards$ = this._store.select(FuelCardReducer.getFuelCards);
  public filesMetaData$ = this._store.select(FuelCardReducer.getFilesMetaData);
  public fuelingMergeData$ = this._store.select(FuelCardReducer.getFuelingMergeData);
  public parseFuelCardFileSuccess$ = this._actionsSubj.pipe(ofType(FuelCardActions.parseFuelCardFileSuccess.type));
  public parseFuelCardFileFailure$ = this._actionsSubj.pipe(ofType(FuelCardActions.parseFuelCardFileFailure.type));
  public saveParsedFuelCardFileSuccess$ = this._actionsSubj.pipe(ofType(FuelCardActions.saveParsedFuelCardFileSuccess.type));
  public saveParsedFuelCardFileFailure$ = this._actionsSubj.pipe(ofType(FuelCardActions.saveParsedFuelCardFileFailure.type));
  public addFuelingMergeSuccess$ = this._actionsSubj.pipe(ofType(FuelCardActions.addFuelingMergeSuccess.type));
  public addFuelingMergeFailure$ = this._actionsSubj.pipe(ofType(FuelCardActions.addFuelingMergeFailure.type));

  constructor(
    private _store: Store<any>,
    private _actionsSubj: ActionsSubject,
  ) {
  }

  public getFuelCards(currentPage: number, pageSize: number): void {
    this._store.dispatch(FuelCardActions.getFuelCards({currentPage, pageSize}));
  }

  public getFilesMetaData(): void {
    this._store.dispatch(FuelCardActions.getFilesMetaData());
  }

  public parseFuelCardFile(form: FormData): void {
    this._store.dispatch(FuelCardActions.parseFuelCardFile({form}));
  }

  public saveParsedFuelCardFile(data): void {
    this._store.dispatch(FuelCardActions.saveParsedFuelCardFile({data}));
  }

  public getFuelingMergeData(unitIds: number[], from: string, to: string): void {
    this._store.dispatch(FuelCardActions.getFuelingMergeData({unitIds, from, to}));
  }

  public updateFuelingMerge(fuelingMergeId, data: FuelingMergeBase): void {
    this._store.dispatch(FuelCardActions.updateFuelingMerge({fuelingMergeId, data}));
  }

  public approveFuelingMergeByIds(fuelingMergeIds: number[]): void {
    this._store.dispatch(FuelCardActions.approveFuelingMergeByIds({fuelingMergeIds}));
  }

  public markAsNotRealFuelingByIds(fuelingMergeIds: number[]): void {
    this._store.dispatch(FuelCardActions.markAsNotRealFuelingByIds({fuelingMergeIds}));
  }

  public markAsRealFuelingByIds(fuelingMergeIds: number[]): void {
    this._store.dispatch(FuelCardActions.markAsRealFuelingByIds({fuelingMergeIds}));
  }

  public getFuelingMergeByIds(fuelingMergeIds: number[]): void {
    this._store.dispatch(FuelCardActions.getFuelingMergeByIds({fuelingMergeIds}));
  }

  public mergeFuelingMerge(data: FuelingMergeBase, id1, id2): void {
    this._store.dispatch(FuelCardActions.mergeFuelingMerge({data, id1, id2}));
  }

  public unMergeFuelingMerge(fuelingMergeId, data: FuelingMergeBase): void {
    this._store.dispatch(FuelCardActions.unMergeFuelingMerge({fuelingMergeId, data}));
  }

  public deleteFuelingMergeById(fuelingMergeId): void {
    this._store.dispatch(FuelCardActions.deleteFuelingMergeByIdSuccess({fuelingMergeId}));
  }

  public addFuelingMerge(data: FuelingMerge): void {
    this._store.dispatch(FuelCardActions.addFuelingMerge({data}));
  }

}
